<template>
  <div class="animated fadeIn">
    <b-card no-body>
      grafana test
      <iframe src="https://grafana-pweb.chorum.fr:3000/d-solo/o6g_y7a4z/atlas-prod-dashboard?orgId=1&refresh=10s&from=1679993030632&to=1679996630632&panelId=15" width="450" height="200" frameborder="0"></iframe>
    </b-card>
  </div>
</template>

<script>
  import {getAccessToken, getBaseUrl, getIdToken, getProvider} from "@/utils/auth";
  import moment from 'moment';
  import { formatDateTime } from "@/utils/communHelper";

  export default {
    name: "Cron",
    data() {
      return {
        dataIsReady: false,
        items: [],
      }
    },
    created() {
      // delete this.$axios.defaults.headers.common["provider"];
      // delete this.$axios.defaults.headers.common["uid"];
      this.$axios({
        url: 'https://grafana-pweb.chorum.fr:3000/api/dashboards/home2',
        method: 'get',
        headers: { 
             'Accept': 'application/json', 
             'Content-Type': "text/plain; application/json",
             'Access-Control-Allow-Origin': '*',
             'Sec-Fetch-Mode': "no-cors",
             'Authorization': 'Bearer eyJrIjoiVHhlMG5xZDhKWk1wM2V5cVBEQk01YXhueG9UV0JGRTQiLCJuIjoiYXRsYXMtZGV2IiwiaWQiOjF9',
        },
        transformRequest: (data, headers) => {
          delete headers.common['Provider'];
          delete headers.common['uid'];
          return data;
        }
      }).then(response => {
          console.log('axios2 grafana : ',response)
        });

      this.$axios
        .get('https://grafana-pweb.chorum.fr:3000/api/dashboards/home', {
          headers: {
            Authorization: 'Bearer eyJrIjoiVHhlMG5xZDhKWk1wM2V5cVBEQk01YXhueG9UV0JGRTQiLCJuIjoiYXRsYXMtZGV2IiwiaWQiOjF9',
            "Content-Type": "text/plain; application/json"
          },
          transformRequest: (data, headers) => {
            delete headers.common['Provider'];
            delete headers.common['uid'];
            return data;
          }
        })
        .then(response => {
          console.log('axios grafana : ',response)
        });

      fetch("https://grafana-pweb.chorum.fr:3000/api/dashboards/home3", {
        // object: {
        //   method: 'GET',
        //   mode: "no-cors",
        //   headers: {
        //     'Accept': 'application/json',
        //     Authorization: 'Bearer eyJrIjoiVHhlMG5xZDhKWk1wM2V5cVBEQk01YXhueG9UV0JGRTQiLCJuIjoiYXRsYXMtZGV2IiwiaWQiOjF9',
        //     "Content-Type": "text/plain; application/json"
        //   }
        // }
        method: "GET",
        mode: "no-cors",
        headers: {
          Authorization: 'Bearer eyJrIjoiVHhlMG5xZDhKWk1wM2V5cVBEQk01YXhueG9UV0JGRTQiLCJuIjoiYXRsYXMtZGV2IiwiaWQiOjF9',
          "Content-Type": "text/plain; application/json"
        }
      })
        .then(res => res.json())
        .then(response => {
          console.log('fetch grafana : ',response)
          console.log(response);
        });
    },
    methods: {
      all() {
        this.$store.commit("IS_LOADING", true);
        this.$axios
          .get("/administration/monitoring-list")
          .then(response => {
            this.$store.commit("IS_LOADING", false);
            this.items = response.data.data;
            this.dataIsReady = true;
          })
          .catch(() => {
            this.handleErrors();
          });
      },
      getFormattedDateTime(textDate) {
        if(textDate !== null && textDate !== ''){
          return formatDateTime(textDate, '/');
        }
      },
      handleErrors() {
        this.$store.commit('IS_LOADING', false);
        this.$swal({
          position: 'top',
          type: 'warning',
          title: 'Attention !!',
          text: 'Une erreur système est survenue, si le problème persiste merci de faire un ticket au support DOSI',
          showConfirmButton: false,
          timer: 4000,
        });
      },
    }
  }
</script>
